import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as moment from 'moment';
import { InputFieldsWrapper } from '.././PTPlusStyled'
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import RadioButton from 'web/components/form-elements/RadioButton';
import { Field } from 'formik'
import { Tooltip } from 'reactstrap';
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import information from "web/assets/images/informationIcon.png";
import { adminRegisterUserApi } from 'redux/actions/adminPtPlus/index';

import AlertModal from 'web/components/AlertModal';

function PaymentMethod(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');

    const saveDisableState = false; //Converted to const to remove the useState hook

    let paymentModeList = [{ value: "PT", label: 'PalletTrader+Credit' }]

    // let invoicePaymentModeList = [{ value: "ach", label: 'ACH' },
    // { value: "card", label: 'Card' }]

    let invoiceScheduleList = [{ value: "DAILY", label: 'By Order', desc: 'Individual invoices will generate by order, upon load completion.' },
    { value: "WEEKLY", label: 'Weekly (7 Days)', desc: 'Invoices will generate every Monday for the previous week (Mon-Sun).' },
    { value: "MONTHLY", label: 'Monthly (30 Days)', desc: 'Invoices will generate on the first of each month for the previous month.' }]

    const [tooltip, setTooltip] = useState(false);
    const [tooltipSection, setTooltipSection] = useState('');
    const iIcon = (infoSection, infoTxt) => {
        return <>
            <img
                id={infoSection}
                src={information}
                style={{ position: "relative", top: "2px", left: '-5px' }}
                alt='information-icon'
            />
            <Tooltip
                placement="right"
                isOpen={tooltip && tooltipSection === infoSection}
                target={infoSection}
                toggle={() => {
                    setTooltip(!tooltip)
                    setTooltipSection(tooltipSection === '' ? infoSection : '')
                }
                }
            >
                {infoTxt}
            </Tooltip>
        </>
    }

    const adminRegisterUserFunc = async () => {
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let accountManagementValues = null
        if(fieldValues.personnelTypeContactName !== '' || fieldValues.personnelTypeEmail !== ''){
            accountManagementValues = {
                personnelType: fieldValues.personnelType,
                contactName: fieldValues.personnelTypeContactName,
                email: fieldValues.personnelTypeEmail
            }
        }
        let data = {
            id: pageProps.tempRegId,
            emailAddress: fieldValues.email?.trim(),
            billToEmailAddress: fieldValues.billToCheckBox ? fieldValues.email?.trim() : fieldValues.billToEmail?.trim(),
            otherContactEmail: fieldValues?.otherToEmail ? fieldValues?.otherToEmail.trim() : null,
            contactNumber: fieldValues.phoneNumber?.trim(),
            customerName: fieldValues.userName?.trim(),
            locationName: fieldValues.businessName?.trim(),
            notes: fieldValues.notes?.trim(),
            paymentMode: fieldValues.paymentModeRadio,
            locationAddress: {
                name: fieldValues.businessName?.trim(),
                contactNumber: fieldValues.phoneNumber?.trim(),
                locationName: fieldValues.businessName?.trim(),
                street: fieldValues.address?.trim(),
                city: fieldValues.city?.trim(),
                state: fieldValues.state?.trim(),
                zipCode: fieldValues.zip?.trim(),
            },
            billingAddress: {
                name: fieldValues.billToCheckBox ? fieldValues.userName?.trim() : fieldValues.billToUserName?.trim(),
                contactNumber: fieldValues.billToCheckBox ? fieldValues.phoneNumber?.trim() : fieldValues.billToPhoneNumber?.trim(),
                locationName: fieldValues.billToCheckBox ? fieldValues.businessName?.trim() : fieldValues.billToBusinessName?.trim(),
                street: fieldValues.billToCheckBox ? fieldValues.address?.trim() : fieldValues.billToAddress?.trim(),
                city: fieldValues.billToCheckBox ? fieldValues.city?.trim() : fieldValues.billToCity?.trim(),
                state: fieldValues.billToCheckBox ? fieldValues.state?.trim() : fieldValues.billToState?.trim(),
                zipCode: fieldValues.billToCheckBox ? fieldValues.zip?.trim() : fieldValues.billToZip?.trim()
            },
            businessInfo: {
                taxId: fieldValues.taxID?.trim(),
                businessUrl: fieldValues.businessURL?.trim(),
                businessDescription: fieldValues.businessDescription?.trim()
            },
            feeStructure: {
                feeType: fieldValues.feeTypeRadio,
                feeTypePercentage: {
                    fee: fieldValues.percentageValue,
                    currency: "USD"
                },
                feeTypeCostPallet: {
                    fee: fieldValues.costPerPalletValue,
                    currency: "USD"
                },
                accountManagement: accountManagementValues,
                commissionType: {
                    commission: fieldValues.commissionTypeRadio === 'COMMISSIONPERCENTAGE' ? 'PERCENTAGE' : 'FLATRATE',
                    value: fieldValues.commissionTypeRadio === 'COMMISSIONPERCENTAGE' ? fieldValues.commissionPercentageValue : fieldValues.commissionFlatRateValue,
                },
            },
            invoiceScheduled: fieldValues.invoiceSchedulePeriod,
            registrationStatus: "COMPLETED"
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminRegisterUserApi(data, token))
        if (response.success) {
            setAlertModalContent('Details saved successfully.')
            setAlertModal(!alertModal)
            setTimeout(() => {
                pageProps.nextStepCallBack('forward', 'step4')
                setAlertModal(false)
            }, 1000)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }
    return (
        <>
            <div>
                <div className='section-header'>
                    <img src={RightArrow} alt="RightArrow" className="right-arrow" />
                    <p>Payment Method<span className='star'>&#42;</span></p>
                </div>

                <div style={{ margin: '10px 0 0 80px' }}>
                    <InputFieldsWrapper>
                        <h6 style={{ fontWeight: 'bold', fontSize: '17px', color: '#000' }}>Payment Mode<span className='star'>&#42;</span></h6>
                        <div className="row mt-3">
                            {paymentModeList.map((value, index) => (
                                <div className="col-md-6">
                                    <div key={index}>
                                        <Field
                                            component={RadioButton}
                                            name="paymentModeRadio"
                                            id={value.value}
                                            defaultValue={paymentModeList[0].value}
                                            onSelect={(e) => {
                                                if (e.target.value === "percentage") {
                                                }
                                            }}
                                            label={value.label}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </InputFieldsWrapper>
                    {/* 
                    <InputFieldsWrapper>
                        <h6>Setup Your Invoice Payment Method<span className='star'>&#42;</span></h6>
                        <div className="row mt-3">
                            {invoicePaymentModeList.map((value, index) => (
                                <div className="col-md-4">
                                    <div key={index}>
                                        <Field
                                            component={RadioButton}
                                            name="invoicePaymentModeRadio"
                                            id={value.value}
                                            defaultValue={invoicePaymentModeList[0].value}
                                            onSelect={(e) => {
                                                if (e.target.value === "percentage") {
                                                }
                                            }}
                                            label={value.label}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </InputFieldsWrapper> */}
                </div>
            </div>

            <div>
                <div className='section-header'>
                    <img src={RightArrow} alt="RightArrow" className="right-arrow" />
                    <p>Setup Your Invoice Schedule<span className='star'>&#42;</span></p>
                </div>

                <div style={{ margin: '10px 0 0 80px' }}>
                    <InputFieldsWrapper>
                        <h6 style={{ marginTop: '-13px' }}>Invoices will be generated based on the below selection.</h6>
                        <div className="row mt-4">
                            {invoiceScheduleList.map((value, index) => (
                                <div className="col-md-4" style={{ display: 'flex' }}>
                                    <div key={index}>
                                        <Field
                                            component={RadioButton}
                                            name="invoiceSchedulePeriod"
                                            id={value.value}
                                            defaultValue={invoiceScheduleList[0].value}
                                            onSelect={(e) => {
                                                if (e.target.value === "percentage") {
                                                }
                                            }}
                                            label={value.label}
                                        />
                                    </div>
                                    {iIcon(value.value, value.desc)}
                                </div>
                            ))}
                        </div>
                    </InputFieldsWrapper>
                </div>
            </div>

            <div className='button-section mt-4'>
                <div style={{ marginLeft: '80px' }}>
                    <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => adminRegisterUserFunc()}>Finish</button>
                    <button className='skip-button' onClick={() => pageProps.skipButtonCall()}>Skip</button>
                </div>
                <div style={{ display: 'flex' }}>
                    <div className='round-wrapper left' onClick={() => pageProps.nextStepCallBack('backward', 'step4')}><p></p></div>
                    <div className={saveDisableState ? 'round-wrapper right disabled' : 'round-wrapper right'} onClick={() => !saveDisableState && adminRegisterUserFunc()}><p></p></div>
                </div>
            </div>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )

}

export default PaymentMethod
